import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { SplitText } from 'gsap/SplitText.js';

gsap.registerPlugin(ScrollTrigger, SplitText);

/**
 * 🎯 Presets d'animations réutilisables
 * Chaque clé correspond à un nom utilisable dans data-revealer
 * Chaque valeur est un objet de configuration GSAP
 */
const revealerPresets = {
  'fade-in': {
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
  },
  'fade-down': {
    y: () => -window.innerHeight * 0.1, // dynamique
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
  },
  'fade-up': {
    y: () => window.innerHeight * 0.1, // dynamique
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
  },
  'fade-left': {
    x: () => -window.innerWidth * 0.1, // dynamique
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
  },
  'fade-right': {
    x: () => window.innerWidth * 0.1, // dynamique
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
  },
  'zoom-in': {
    scale: 0.8,
    opacity: 0,
    duration: 1,
    ease: 'power2.out',
  },
};

/**
 * 🔍 Fonction utilitaire : parse un effet avec paramètres inline
 * Exemple : "fade-up:duration=2:delay=0.5"
 * - "fade-up" → preset de base
 * - "duration=2" et "delay=0.5" → écrasent les valeurs du preset
 */
function parseEffect(effectStr) {
  const [name, ...params] = effectStr.split(':');
  let config = { ...(revealerPresets[name] || {}) };

  params.forEach((param) => {
    const [key, value] = param.split('=');
    if (key && value !== undefined) {
      config[key.trim()] = isNaN(value) ? value.trim() : parseFloat(value);
    }
  });

  return config;
}

/**
 * 🚀 Fonction principale : initialise toutes les animations data-revealer
 */
export function initRevealers() {
  // 1️⃣ Sélectionner tous les éléments avec data-revealer
  gsap.utils.toArray('[data-revealer]').forEach((el) => {
    const attr = el.getAttribute('data-revealer')?.trim();
    if (!attr) return;

    const effects = [];

    // 2️⃣ Parsing des effets
    if (attr.startsWith('{')) {
      try {
        effects.push(JSON.parse(attr));
      } catch (e) {
        console.warn('Config data-revealer invalide :', attr, e);
        return;
      }
    } else {
      attr.split('|').forEach((effectStr) => {
        effectStr = effectStr.trim();
        if (!effectStr) return;

        const presetName = effectStr.split(':')[0];
        if (revealerPresets[presetName]) {
          effects.push(parseEffect(effectStr));
        }
      });
    }

    // 3️⃣ Chaque élément a son propre ScrollTrigger
    effects.forEach((props) => {
      gsap.from(el, {
        ...props,
        scrollTrigger: {
          trigger: el,
          start: 'top 95%',
          // toggleActions: 'play none none reverse',
          once: true,
          invalidateOnRefresh: true
        },
      });
    });
  });
}

// window.addEventListener('load', () => {
//   setTimeout(initRevealers, 2500);
// });